import { AxiosRequestConfig } from 'axios';
import { createAction, createAsyncAction } from 'typesafe-actions';
import { ApiError, Statements } from '@types';
import { config } from '../../config';

export const fetchStatementAsync = createAsyncAction(
    [
        'statement/FETCH_STATEMENT_REQUEST',
        (loanNumber: string, uid: string | Array<string>) => {
            return {
                url: `${config.env('awsUrl')}/api/v1/selfserv/documents/${loanNumber}/categories/list`,
                method: 'get',
                metadata: { loanNumber, uid }
            } as AxiosRequestConfig & { metadata: { loanNumber: string; uid: string | Array<string> } };
        }
    ],
    ['statement/FETCH_STATEMENT_SUCCESS', (response: Statements, loanNumber: string) => ({ response, loanNumber })],
    ['statement/FETCH_STATEMENT_ERROR', (error: ApiError, loanNumber: string) => ({ error, loanNumber })],
    'statement/FETCH_STATEMENT_CANCEL'
)();

export const clearStatementError = createAction('statement/FETCH_STATEMENT_CLEAR')();
